import { defineMessages } from 'react-intl';

export default defineMessages({
  repairerInfoTitle: {
    id: 'view.procedure.repairerInfoTitle',
    defaultMessage: "Repairer's contact info",
  },
});
